import { render, staticRenderFns } from "./ExpanderBox.vue?vue&type=template&id=2343f639&scoped=true&"
import script from "./ExpanderBox.vue?vue&type=script&lang=ts&"
export * from "./ExpanderBox.vue?vue&type=script&lang=ts&"
import style0 from "./ExpanderBox.vue?vue&type=style&index=0&id=2343f639&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2343f639",
  null
  
)

export default component.exports